import type { AgentQueryWait } from './model';

export function parseQueryWait(value: unknown): AgentQueryWait | undefined {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return;
  }
  const status = value as Partial<AgentQueryWait>;
  if (
    typeof status.waitId !== 'string' ||
    !status.waitId ||
    typeof status.agentMessageId !== 'string' ||
    !status.agentMessageId ||
    typeof status.state !== 'string' ||
    !status.state ||
    typeof status.phase !== 'string' ||
    !status.phase ||
    typeof status.messageStatus !== 'string' ||
    !status.messageStatus ||
    typeof status.attemptId !== 'string' ||
    !status.attemptId ||
    typeof status.canSendMessage !== 'boolean' ||
    typeof status.pollAfterMs !== 'number' ||
    !Number.isFinite(status.pollAfterMs) ||
    status.pollAfterMs <= 0
  ) {
    return;
  }
  return {
    waitId: status.waitId,
    agentMessageId: status.agentMessageId,
    state: status.state,
    phase: status.phase,
    messageStatus: status.messageStatus,
    attemptId: status.attemptId,
    canSendMessage: status.canSendMessage,
    pollAfterMs: status.pollAfterMs,
    jobStatus: status.jobStatus,
    errorCode: status.errorCode,
  };
}

export function queryWaitMessageKey(
  wait: { phase: string; state: string; canSendMessage: boolean } | undefined,
  stopping = false,
) {
  if (
    stopping ||
    wait?.state === 'CANCEL_REQUESTED' ||
    (wait?.state === 'CANCELLED' && !wait.canSendMessage)
  ) {
    return 'agent.query.stopping';
  }
  if (wait?.state === 'RESUMING' || wait?.state === 'READY' || wait?.state === 'DISPATCHING') {
    return 'agent.query.resuming';
  }
  switch (wait?.phase) {
    case 'ORDER_LOSS_QUERYING':
      return 'agent.query.orderLossWaiting';
    case 'ORDER_LOSS_LONG_RANGE':
      return 'agent.query.orderLossWaitingLongRange';
    case 'ORDER_LOSS_STILL_QUERYING':
      return 'agent.query.orderLossWaitingLonger';
    default:
      return 'agent.query.waiting';
  }
}
